module.exports = __webpack_public_path__ + "img/Aggregation_Zugänglichkeit.f8ef1bbb.png";